import type { MessageKind, FilterType } from './types';

export const MESSAGE_KIND_CONFIG: Record<MessageKind, {
    label: string;
    icon: string;
    color: string;
    bgColor: string;
    borderColor: string;
    dotColor: string;
}> = {
    critical: {
        label: 'Критично',
        icon: 'alert-circle',
        color: 'text-rose-600 dark:text-rose-400',
        bgColor: 'bg-rose-50 dark:bg-rose-900/20',
        borderColor: 'border-rose-200 dark:border-rose-500/30',
        dotColor: 'bg-rose-500',
    },
    warning: {
        label: 'Предупреждение',
        icon: 'alert-triangle',
        color: 'text-amber-600 dark:text-amber-400',
        bgColor: 'bg-amber-50 dark:bg-amber-900/20',
        borderColor: 'border-amber-200 dark:border-amber-500/30',
        dotColor: 'bg-amber-500',
    },
    info: {
        label: 'Информация',
        icon: 'info',
        color: 'text-blue-600 dark:text-blue-400',
        bgColor: 'bg-blue-50 dark:bg-blue-900/20',
        borderColor: 'border-blue-200 dark:border-blue-500/30',
        dotColor: 'bg-blue-500',
    },
    ok: {
        label: 'Восстановлено',
        icon: 'check-circle',
        color: 'text-emerald-600 dark:text-emerald-400',
        bgColor: 'bg-emerald-50 dark:bg-emerald-900/20',
        borderColor: 'border-emerald-200 dark:border-emerald-500/30',
        dotColor: 'bg-emerald-500',
    },
    resolved: {
        label: 'Решено',
        icon: 'check-circle-2',
        color: 'text-cyan-600 dark:text-cyan-400',
        bgColor: 'bg-cyan-50 dark:bg-cyan-900/20',
        borderColor: 'border-cyan-200 dark:border-cyan-500/30',
        dotColor: 'bg-cyan-500',
    },
};

export const FILTER_CONFIG: Record<FilterType, { label: string; badge?: MessageKind }> = {
    all: { label: 'Все' },
    unread: { label: 'Непрочитанные' },
    critical: { label: 'Критичные', badge: 'critical' },
    warning: { label: 'Предупреждения', badge: 'warning' },
    info: { label: 'Информация', badge: 'info' },
    archived: { label: 'Архив' },
};

export const MESSAGES_PAGE_CONFIG = {
    pageSize: 20,
    maxMessages: 1000,
    refreshInterval: 30000,
    animationDuration: 0.3,
    virtualItemHeight: 88,
    overscan: 5,
} as const;